import React from 'react';
import { shouldUpdate } from 'recompose';

export default shouldUpdate(() => false)(
  () => (
    <iframe
      title="github-button"
      src="https://ghbtns.com/github-btn.html?user=panayi&type=follow"
      frameBorder="0"
      scrolling="0"
      width="110"
      height="20"
    />
));



// WEBPACK FOOTER //
// ./src/app/components/github_button/index.js